import cx from 'classnames';
import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { WideView } from '@components/wideView/WideView';
import { IPAD1024 } from '@shared/styles/breakpoints';
import typography from '~styles/typography.scss';
import { ImageLoader } from '../components/ImageLoader';
import { type Restaurant } from './apiHelpers';
import { ReservationAttributesGrid } from './ReservationAttributesGrid';
import styles from './ReservationCard.scss';
import { ReservationStatus } from './ReservationStatus';
import { type ReservationStatusLabel } from './statusHelpers';

export interface ReservationCardProps {
  children?: ReactNode;
  date: string;
  eventName?: null | string;
  guestCount: number;
  linkTo: string;
  listingPublicName: null | string;
  restaurant: Restaurant;
  status?: ReservationStatusLabel;
  time: string;
}

export const ReservationCard = ({
  children,
  date,
  eventName,
  guestCount,
  linkTo,
  listingPublicName,
  restaurant,
  status,
  time,
}: ReservationCardProps) => (
  <li className={styles.container}>
    <Link className={styles.linkContainer} to={linkTo}>
      <div className={styles.imageContainer}>
        <ImageLoader
          src={`${process.env.RESTAURANT_IMAGE_BASE_URL}/${restaurant.id}/main.jpg`}
        />
      </div>
      <div className={styles.content}>
        <header>
          <h2 className={cx(typography.d4, styles.restaurantName)}>
            {restaurant.name}
          </h2>
          {eventName && (
            <p className={cx(typography.t2, styles.eventName)}>
              Event: {eventName}
            </p>
          )}
          {status && <ReservationStatus status={status} />}
        </header>
        <WideView
          breakpoint={IPAD1024}
          narrowElement={
            <ReservationAttributesGrid
              date={date}
              guestCount={guestCount}
              publicName={listingPublicName}
              time={time}
            />
          }
          wideElement={
            <ReservationAttributesGrid
              date={date}
              guestCount={guestCount}
              publicName={listingPublicName}
              time={time}
              variant="inline"
            />
          }
        />
      </div>
    </Link>
    {children}
  </li>
);
